/* @flow */

export const notificationErrorLevel = 'error';
export const notificationSuccessLevel = 'success';
export const notificationInfoLevel = 'info';
export const notificationWarningLevel = 'warning';

export const notificationTakeOverType = 'takeOver';
export const notificationTopType = 'top';
export const notificationSecondaryType = 'secondary';
